import React from 'react';

import { faFileContract } from '@fortawesome/pro-regular-svg-icons';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { Link } from 'react-router-dom';

import AutocompleteSearch from '../components/AutocompleteSearch';
import axios from '../modules/axios';
import EditMandat from '../pages/mandat/EditMandat';

export default {
  title: 'Mandats',
  name: 'mandats',
  icon: faFileContract,
  resource: 'mandat_commercialisation',
  primaryKey: 'idmandat',
  query: { _associations: 'avenants,type,promoteur' },
  filters: { mandat_commercialisation_deleted: 0 },
  sort: '-idmandat',
  head: {
    type: 'Type',
    num: 'Numéro',
    promoteur: 'Promoteur',
    url_serveur: 'Mandat',
    date_signature: 'Date Signature',
    date_fin: 'Date fin',
    avenants: 'Avenants',
  },
  list: ({ values }) => [
    values.type?.nom,
    values.num,
    <Link to={{ pathname: `/i9/promoteurs/${values.promoteur?.idpromoteur}` }}>{values.promoteur?.nom}</Link>,
    values.url_serveur ? (
      <a href={values.url_serveur} target='_blank' rel='noopener noreferrer'>
        Mandat
      </a>
    ) : (
      ''
    ),
    values.date_signature,
    values.date_fin,
    values.avenants?.map(avenant => (
      <p>
        <a href={avenant.url_serveur}>{avenant.num}</a>
      </p>
    )),
  ],
  filter: ({ values, props, handleSubmit, setFieldValue, filters }) => [
    <FormControl {...props}>
      <InputLabel>
        <strong>Mandat</strong>
      </InputLabel>
      <Select
        {...props}
        label='Mandat'
        name='mandat_commercialisation_deleted'
        value={values.mandat_commercialisation_deleted}
        displayEmpty
        onChange={e => {
          setFieldValue('mandat_commercialisation_deleted', e.target.value);
          handleSubmit();
        }}
      >
        <MenuItem value={null}>Tous</MenuItem>
        <MenuItem value={0}>Actifs</MenuItem>
        <MenuItem value={1}>Clôturés</MenuItem>
      </Select>
    </FormControl>,
    filters?.idpromoteur ? null : (
      <AutocompleteSearch
        {...props}
        resource='promoteur'
        attribute='nom'
        label='Promoteur'
        onChange={(event, value) => {
          setFieldValue('idpromoteur', value?.idpromoteur);
          handleSubmit();
        }}
      />
    ),
  ],
  edit: props => [<EditMandat key='edit-mandat' {...props} />],
  customUpdate: async ({ newValues }) => {
    // Update the mandat
    await axios.patch(`mandat_commercialisation/${newValues.idmandat}`, newValues);
    // Update the mandat_progs
    await axios.patch(`mandat_commercialisation_programmes`, {
      idmandat: newValues.idmandat,
      idprogs: newValues.selected_programmes,
    });
  },
  customDelete: async id => {
    // Delete the mandat_progs
    await axios.delete(`mandat_with_progs/${id}`);
  },
  csv: values => [
    values.type?.nom,
    values.avenants?.length,
    values.num,
    values.date_signature,
    values.date_fin,
    values.url_serveur,
  ],

  add: true,
  popup: true,
  show: true,
  remove: true,
};
